import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useAddGsuiteAccountMutation } from "@/redux/services/gsuitesApi"
import { setToast } from "@/redux/toastSlice"
import type { AddGsuiteAccountPayload } from "@/types/entities/gsuite-account"

export const useAddGsuiteAccount = () => {
  const dispatch = useAppDispatch()
  const [addGsuiteAccount, response] = useAddGsuiteAccountMutation()

  const handleAddGsuiteAccounts = async (body: AddGsuiteAccountPayload) => {
    try {
      const response = await addGsuiteAccount(body).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success add account",
          }),
        )
      }
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(message)
    }
  }

  return { addGsuiteAccount: handleAddGsuiteAccounts, response }
}
